// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__18Itw","left":"InfoRow_left__8fhnX"};